import { globalNotification } from '@/composables/use-app-notification'
import { router } from '@/config/router/router'
import axios, { AxiosError } from 'axios'
import qs from 'qs'

export interface Config {
  baseURL: string
  headers: {
    [key: string]: string
  }
}

const defaultConfig: Config = {
  // TODO перенести в envs/config переменные
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
}

export const DefaultAPIInstance = (
  config: Partial<Config> | undefined,
  callbackFn: (status: number) => void,
) => {
  const instance = axios.create({
    ...defaultConfig,
    ...config,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  })

  instance.interceptors.response.use(
    (r) => r,
    (err) => onRejectedResponse(err, callbackFn),
  )

  return instance
}

interface DetailError {
  detail: {
    [key: string]: string
  }
}

const messageKeys: { [key: string]: string } = {
  serviceError: 'error.service-error-title',
  default: 'error.default-error-title',
}

export const onRejectedResponse = async (
  payload: AxiosError<DetailError>,
  cb: (status: number) => void,
) => {
  if (payload.response?.status === 401) {
    cb(payload.response?.status)
    router.push('/login')

    return
  }

  if (payload.response?.data?.detail && Object.values(payload.response?.data?.detail).length > 0) {
    Object.keys(payload.response?.data?.detail).map((k) => {
      const messageKey = messageKeys[k] ? messageKeys[k] : messageKeys['default']

      if (k === 'code') return

      globalNotification.errorWithT({ messageKey, description: payload.response?.data?.detail[k] })
    })
  } else if (payload.response?.status === 500) {
    globalNotification.errorWithT({
      messageKey: 'error.server-error',
      description: 'error.server-error-description',
    })
  }
  return Promise.reject(payload)
}
